import { Component, h } from 'preact';

class PymChild extends Component {
  constructor(props) {
    super(props);

    const { polling } = this.props;

    let opts = {};
    if (polling) opts.polling = polling;

    this.child = new pym.Child(opts);
  }

  componentDidMount() {
    this.child.sendHeight();
  }

  componentDidUpdate() {
    this.child.sendHeight();
  }

  render({ class: klass }) {
    return <div class={klass}>{this.props.children}</div>;
  }
}

export default PymChild;
